import React from 'react';

import { entityGeneralSetupService } from '../services/entityGeneralSetupService';
import { AddSeatsModal } from '../containers/AddSeatsModal/AddSeatsModal';
import { openModal } from '../../shared/utils/reactUtils/openModal/openModal';
import { isCoachSeatsLimitReached } from '../../shared/utils/coachSeatsUtils/coachSeatsUtils';

export const useCoachSeatsValidation = (entityId: number) => {
  const handleAddCoachValidation = async (onValid: () => void) => {
    const seats = await entityGeneralSetupService.getCoachSeats(entityId);

    if (isCoachSeatsLimitReached(seats)) {
      openModal((closeModal) => (
        <AddSeatsModal
          open
          onClose={closeModal}
          entityId={entityId}
          coachSeats={seats.coachSeats}
          usedSeats={seats.usedSeats}
        />
      ));
    } else {
      onValid();
    }
  };

  return { handleAddCoachValidation };
};
